//import React from "react";
import React, { useState, useEffect, useContext} from 'react';

// react component for creating dynamic tables
import ReactTable from "react-table";
import { useTranslation } from 'react-i18next';

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Search from "@material-ui/icons/Search";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import { SessionContext } from "beaktShared/services/session";

import { useGetApi, UsePostApi, UsePutApi,UseDeleteApi } from "beaktShared/services/crudeApiService";
import { GerenciaModal } from "beaktShared/views/Crud/ModalDetail";
import { GerenciaAlertDelete } from "beaktShared/views/Crud/AlertDelete";
import EspecialidadeForm from "./EspecialidadeForm";

import styles from "assets/jss/material-dashboard-pro-react/views/crudeStyle.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
const useStyles = makeStyles(styles);

export default function EspecialidadeList() {
    const { t } = useTranslation(); 

    const session = useContext(SessionContext);

    const endPoint = 'especialidades/';  
   
    const [showFormView, setshowFormView] = React.useState(false);
    const [item, setItem] = useState({});          
    const [loadingForm, setLoadingForm] = React.useState(false);

    const getEndPoint = () => {
        let endPointGet = "";
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
            endPointGet =  endPoint +"byfranquia/"+ session.franquiaId;
        else //Acessando tela pelo modulo Clinica   
            endPointGet = endPoint +"byestabelecimento/"+ session.estabelecimentoId;
        return  endPointGet;
    }
    const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi(getEndPoint());
    
    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem,color) => { 
        setMensagemNotification(mensagem);
        setColorNotification(color);      
        setNotification(true);
        setTimeout(function() {
            setNotification(false);
        }, 6000);       
    };
  
    const handleAdd = item => {
        
        var newitem = "";
        if(session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            newitem = {
                ...item,
                cadastradoFranquia: true,
                franquiaId:session.franquiaId
            };
        }
        else
        {           
            var estabelecimentoEspecialidades = [
                {
                    especialidadeId: item.especialidadeId,
                    estabelecimentoId: session.estabelecimentoId
                }
            ];
            newitem = {...item,estabelecimentoEspecialidades};
        }
        
        var vefifyExists = list.filter(obj => {
            return obj.especialidadeId === item.especialidadeId;
        });

        if(vefifyExists.length > 0)
        {
            setLoadingForm(true);
            UsePutApi(endPoint,item.especialidadeId,newitem).then(result=>{
                setLoadingForm(false);
                if(result.status !== 200)
                {                                    
                    showNotification(result.message.message,'danger');
                    return false; 
                } 
                    
                const updateList = list.map(l => (l.especialidadeId === item.especialidadeId ? item : l));
                setListAtualiza(updateList);
                handleView(true);
                showNotification(result.message,'success');
                return true;                 
            });             
        }
        else
        {    
            setLoadingForm(true);
            UsePostApi(endPoint,newitem).then(result=>{                
                setLoadingForm(false);  
                if(result.status !== 201)
                {                                     
                    showNotification(result.message.message,'danger');
                    return false; 
                } 
                
                const addItemList = [...list, result.data];
                setListAtualiza(addItemList); 
                handleView(true);
                showNotification(t('information_message.registered_successfully'),'success');
                return true;                
            });         
        }

        return false;        
    };   

    const handleView = (resetItem) => {    
        if(resetItem)
            setItem({});
        let show = showFormView === true ? false : true;
        setshowFormView(show);             
    };

    const [detailModal, setConfModal] = GerenciaModal();
    const handleDetail = row => {  
        
        const bodyDetail=(
        <div>
            <p><b>{t('label.specialty')}:</b> {row.descricao}</p>
            <p><b>{t('label.status')}</b> {row.ativo === true ? t('label.active') : t('label.inactive')}</p>
        </div>);

        setConfModal({ 
            showmodal: true,
            dataShow: bodyDetail
          });
    };

    const handleEdit = row => {       
        setItem(row);
        handleView(false);
    };

    const [alertDelete, setAlertDelete] = GerenciaAlertDelete();
    const handleDelete = id =>{
        var userDeletadoId = session.id;
        UseDeleteApi(endPoint,id,userDeletadoId).then(result=>{
            if(result.status !== 200)
            {                                    
                setAlertDelete({statusAlert:2});
                showNotification(result.message,'danger');
                return false; 
            } 

            var listFiltered = list.filter(obj => {
                return obj.especialidadeId !== id;
            });
            setListAtualiza(listFiltered);                
            setAlertDelete({statusAlert:3}); 
            return true;
        });         
    };

    const showAlertDelete = id =>{
        setAlertDelete({
            statusAlert:1,
            idToDeleteRecieve:id
        }); 
    }  
    useEffect(() => {  
        if(alertDelete.isToDelete)
            handleDelete(alertDelete.idToDeleteSend);      
    // eslint-disable-next-line     
    }, [alertDelete]);

    const columnsProp = [{
        Header: t('label.description'),
        accessor: "descricao"
    },
    {
        Header: t('label.status'),
        accessor: "ativo",
        Cell: (row) => { 
            if (row.original.ativo)
                return "Ativo"
            else
                return "Inativo"
        },
    }]
    const columnsAcao = [        
        {
            Header: t('label.actions'),
            Cell: row => (
                <div className="actions-right">                        
                <Button
                    justIcon
                    round
                    simple                            
                    color="info"
                    className="info"
                    onClick={() => handleDetail(row.original)}
                >
                <Tooltip title={t('label.detail')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Search />
                </Tooltip>
                </Button>{" "}               
                {((row.original.cadastradoFranquia && session.franquiaId !== 0)
                 ||(row.original.cadastradoFranquia === false && session.estabelecimentoId !== 0)) &&
                <>
                <Button
                    justIcon
                    round
                    simple
                    color="success"
                    className="edit"
                    onClick={() => handleEdit(row.original)}
                >
                <Tooltip title={t('label.to_edit')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Edit />
                </Tooltip>
                </Button>{" "}
                <Button
                    justIcon
                    round
                    simple
                    color="danger"
                    className="remove"
                    onClick={() => showAlertDelete(row.original.especialidadeId)} 
                >
                <Tooltip title={t('button.delete')} id="tooltip-top" placement="top" classes={{ tooltip: classes.tooltip }} >
                <Close />
                </Tooltip>
                </Button>{" "}
                </>
                }
            </div>
            ),
            sortable: false,
            filterable: false
        }
    ];
    const columns = [...columnsProp,...columnsAcao]

    const classes = useStyles();
    return (
        <div>

            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {showFormView && 
                <EspecialidadeForm addItem={handleAdd} item={item} handleView={handleView} loading={loadingForm} />} 
            
            {!showFormView &&
                <GridContainer>            
                <GridItem xs={12}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Assignment />
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('register.list_of_specialties')}</h4>
                        </CardHeader>
                        <CardBody>
                            <Button
                                color="primary"
                                className={classes.newButton}
                                onClick={() => handleView(true)}
                            >
                               {t('button.new')} 
                            </Button>                           

                            {isErrorGetList && <div>{t('error_message.loading_error')}...</div>}
                            <ReactTable
                                loading = {isLoadingList}
                                data={list}
                                filterable
                                defaultFilterMethod = {noCaseSensitive}
                                columns={columns}
                                defaultPageSize={10}
                                minRows={5}
                                showPaginationBottom={true}
                                className="-striped -highlight"
                                previousText={t('button.previous')}
                                nextText={t('button.next')}
                                loadingText={t('label.loading')+"..."}
                                noDataText={t('information_message.no_records_found')+"!"}
                                pageText={t('label.page')}
                                ofText={t('label.of')}
                                rowsText={t('label.rows')}
                            />
                        </CardBody>
                    </Card>
                </GridItem>            
            </GridContainer>
            }
            
            {alertDelete.componente}
            {detailModal}            
        </div>
    );
}
